<template>
	<div class="footer">
		<div class="main flex-align">
			<div class="content">
				<!--<div class="logoBox flex-align">
					<img src="/assets/images/mainbody/logo-rect.png">
					<div class="text">XX体育</div>
				</div>-->
				<div class="list flex-center">
					<div class="item flex-center" 
					v-for="(item,index) in list"
					:key="index"
					@click="handleClick(item)">{{$t(item.key,item.label)}}</div>
				</div>
				<div class="copyright">{{$t('other.common.copyright', '版权所有')}}2022-2026</div>
			</div>
			<div class="right">
				<div class="flex-column">
					<div class="downloadAPP">下载APP</div>
					<div class="qrCodeBox flex-center">
						<!-- <img :src="`/assets/images/mainbody/app_download_url.png?WebVersion=${$WebVersion}`" > -->
						<vue-qr style="vertical-align: middle;" v-if="installGuideUrl"
							:text="installGuideUrl"
							:size="182"
							:logoMargin="2"
							level="H"
							ref="roomQRcodeRef"
						></vue-qr>
					</div>
				</div>
				
			</div>
		</div>
	</div>
</template>

<script setup>
	import vueQr from "vue-qr/src/packages/vue-qr.vue";
	import { ref, reactive, getCurrentInstance, onMounted, computed, watch } from "vue";
	import {useStore} from '@/store';
	let store = useStore();
	let startUp = computed(()=>store.state.startUp);
	let {proxy} = getCurrentInstance();
    
	let list = reactive([
		{
			value:0,key:'route.aboutUs',label:'关于我们',path:'/other/aboutUs/index',
		},
		{
			value:1,key:'route.platformSpe',label:'平台规范',path:'/other/anchor-related/liveStreamProtocol',
		},
		{
			value:2,key:'route.startBroadcasting',label:'我要开播',path:'/other/anchor-related/broadcastTutorial',
		},
		{
			value:3,key:'route.help',label:'帮助中心',path:'/other/user-related/accountIssue',
		},
		{
			value:4,key:'route.anchorTools',label:'主播工具',path:'/other/anchor-related/computerLiveStream',
		},
	]);
	let handleClick = (item)=>{
		proxy.$router.push({
			path:item.path,
		})
	}
	onMounted(()=>{
		getInstallGuideUrl();
	})
	let installGuideUrl = ref('');
	watch(()=>startUp.value,()=>{
		getInstallGuideUrl();
	},{deep:true})
	// 当前协议://{H5域名}/openInstallGuide
	let getInstallGuideUrl = ()=>{
		if(startUp.value.safeDomains?.length==0) {
			console.log('未配置服务地址，敬请期待！')
			return;
		}
		let protocol = window.location.protocol;
		let _safeDomains = startUp.value.safeDomains?.map(e=>e.replace(RegExp('https{0,1}://'), ''));
		let safeDomain = _safeDomains[0];
		installGuideUrl.value = `${protocol}//${safeDomain}/openInstallGuide`;
	}
	
</script>

<style lang="scss" scoped>
    .footer {
        width: 100%;
        min-width: 1240px;
        height: 164px;
        background: #24282B;
        color: #fff;
        flex-direction: column;

        .main {
            width: 1240px;
            margin: 0 auto;
            padding-top: 1px;

            .content {
                flex: 1;

                .logoBox {
                    margin: 30px 0;

                    img {
                        width: 36px;
                        height: 36px;
                        margin-right: 3px;
                    }

                    .text {
                        font-family: BigruixianBlackGBV;
                        font-weight: 400;
                        font-size: 28px;
                        color: #FFFFFF;
                    }
                }

                .list {
                    margin: 20px 0;
                    display: flex;

                    .item {
                        // width:123px;
                        padding: 0 20px;
                        height: 13px;
                        border-right: 1px solid #939495;
                        font-family: PingFang-SC-Bold;
                        // font-weight: bold;
                        font-size: 13px;
                        color: #939495;
                        cursor: pointer;

                        &:first-child {
                            padding: 0 20px 0 0;
                        }

                        &:last-child {
                            border-right: unset;
                        }
                    }
                }

                .copyright {
                    font-family: PingFang-SC-Bold;
                    // font-weight: bold;
                    font-size: 12px;
                    color: #939495;
                    margin-left: 536px;
                }
            }

            .right {
                .downloadAPP {
                    font-family: PingFang-SC-Bold;
                    // font-weight: bold;
                    font-size: 14px;
                    color: #FFFFFF;
                    text-align: center;
                    margin: 28px 0 10px;
                }

                .qrCodeBox {
                    width: 84px;
                    height: 84px;
                    background: rgba(255,255,255,1);
                    box-shadow: 0px 0px 6px rgba(0,45,0,0.16);
                    border-radius: 4px;
					img{
						width:75px;
					}
                }
            }
        }
    }
</style>